export interface IWPLinkRequest {
  identifier: string;
  username: string;
  app_password: string;
  creatorOwnerId: number;
  lmsTypeID: number;
}
export interface IMentorkitLMSLinkRequest {
  identifier: string;
  accessToken: string;
  creatorOwnerId: number;
  lmsTypeID: number;
}

export interface ISynthesiaLinkRequest {
  identifier: string;
  accessToken: string;
  creatorOwnerId: number;
  lmsTypeID: number;
}

export enum ELMSType {
  WordPress = 1,
  Mentorkit_LMS = 2,
  Synthesia = 3,
}

export interface ILMSIntegrationResponse {
  id?: string;
  success?: boolean;
  message?: string;
  lmsType: ELMSType;
}

export interface IIntegrationItem {
  customerId: number;
  url: string;
  lmsTypeId: ELMSType;
  targetCourse?: { name: string; id: number };
  ownerId?: number;
}

export interface IAddLMSLinkRequest {
  lmsCustomerId: number;
  creatorCourseId: number;
  lmsTypeId: number;
  lmsCourseName: string;
  identifierLMSCourse: string;
  publishURL?: string;
}

export interface IAddLMSLinkResponse {
  message: string;
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  creatorCourseId: number;
  lmsTypeId: number;
  lmsCourseName: string;
  identifierLMSCourse: string;
  publishURL?: string;
}

export interface ICourseLMSLinkItem {
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  creatorCourseId: number;
  lmsTypeId: ELMSType;
  lmsCourseName: string;
  identifierLMSCourse: string;
  publishURL?: string;
}

export interface ILMSUpdateLinkItem {
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  lmsCourseName: string;
  identifierLMSCourse: string;
}

export interface IGetLinksByCourseResponse {
  creatorCourseId: number;
  count: number;
  items: ICourseLMSLinkItem[];
}

export interface IExportToPublishRequest {
  courseId: number;
  version: string;
  language: string;
  collectAllFiles: boolean;
  customerLmsLinkId: number | null;
  coverImageUrl: string | null;
}

export interface IPublishResult {
  lmsCustomerId: number;
  integrationUrl: string;
  success: boolean;
  wpBody: string;
  publishLog: {
    creatorCourseId: number;
    lmsCustomerId: number;
    lmsCustomerCourseId: number;
    publishDate: string;
    ownerId: number;
    caption: string;
    lmsCustomerUrl: string;
    lmsCourseName: string;
    lmsTypeId: number;
  };
}

export interface IExportToPublishResponse {
  courseId: number;
  count: number;
  results: IPublishResult[];
}

export interface IPublishLogEntry {
  creatorCourseId: number;
  lmsCustomerId: number;
  lmsCustomerCourseId: number;
  publishDate: string;
  ownerId: number;
  caption: string;
  lmsCustomerUrl: string;
  lmsCustomer: string;
  lmsCourseName: string;
  lmsTypeId: number;
}

export interface IGetPublishLogsByCourseResponse {
  creatorCourseId: number;
  count: number;
  logs: IPublishLogEntry[];
}

export interface ISynthesiaKeyResponse {
  ownerId: number;
  lmsCustomerId: number;
  identifier: string;
  token: string;
}
